import { industryConstants,alertConstants } from '../_constants'
import { industryService } from '../_services'
import { alertActions } from '../_actions'
export const industryActions = {
  addIndustry,
  getIndustry,
  deleteIndustry,
  getIndustryByPage,
  getIndustryById,
  updateIndustry,
  updateFilters,
  clearAllMessages
}
function clearAllMessages() {
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}
function updateFilters(industryId) {
  return dispatch => {
    dispatch(request(industryId))

    industryService.updateFilters(industryId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: industryConstants.UPDATE_FILTER_REQUEST, response } }
  function success(response) { return { type: industryConstants.UPDATE_FILTER_SUCCESS, response } }
  function failure(error) { return { type: industryConstants.UPDATE_FILTER_FAILURE, error } }
}

function addIndustry(industry) {
  return dispatch => {
    dispatch(request(industry))

    industryService.addIndustry(industry)
      .then(
        industry => {
          console.log(industry)
          dispatch(success(industry))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(industry) { return { type: industryConstants.ADD_REQUEST, industry } }
  function success(industry) { return { type: industryConstants.ADD_SUCCESS, industry } }
  function failure(error) { return { type: industryConstants.ADD_FAILURE, error } }
}

function getIndustry() {
  return dispatch => {
    dispatch(request())

    industryService.getIndustry()
      .then(
        industry => {
          console.log(industry)
          dispatch(success(industry))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(industry) { return { type: industryConstants.GETALL_REQUEST, industry } }
  function success(industry) { return { type: industryConstants.GETALL_SUCCESS, industry } }
  function failure(error) { return { type: industryConstants.GETALL_FAILURE, error } }
}
function getIndustryByPage(start,pageSize,search,sectorId) {
  return dispatch => {
    dispatch(request({start,pageSize,search,sectorId}))
    industryService.getIndustryByPage(start,pageSize,search,sectorId)
      .then(
        industry => {
          console.log('industry' + industry)
          if(industry.data)
            dispatch(success(industry))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(industry) { return { type: industryConstants.GETALL_PAGE_REQUEST, industry } }
  function success(industry) { return { type: industryConstants.GETALL_PAGE_SUCCESS, industry } }
  function failure(error) { return { type: industryConstants.GETALL_PAGE_FAILURE, error } }
}

function deleteIndustry(id,userId) {
  return dispatch => {
    dispatch(request(id,userId))
    industryService.deleteIndustry(id,userId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: industryConstants.DELETE_REQUEST, response } }
  function success(response) { return { type: industryConstants.DELETE_SUCCESS, response } }
  function failure(error) { return { type: industryConstants.DELETE_FAILURE, error } }
}
function getIndustryById(id) {
  return dispatch => {
    dispatch(request())

    industryService.getIndustryById(id)
      .then(
        industry => {
          console.log(industry)
          dispatch(success(industry))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(industry) { return { type: industryConstants.GETBYID_REQUEST, industry } }
  function success(industry) { return { type: industryConstants.GETBYID_SUCCESS, industry } }
  function failure(error) { return { type: industryConstants.GETBYID_FAILURE, error } }
}
function updateIndustry(industry,id) {
  return dispatch => {
    dispatch(request(industry))
    industryService.updateIndustry(industry,id)
      .then(
        industry => {
          console.log('industry' + industry)
          if(industry.message)
            dispatch(success(industry))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(industry) { return { type: industryConstants.UPDATE_REQUEST, industry } }
  function success(industry) { return { type: industryConstants.UPDATE_SUCCESS, industry } }
  function failure(error) { return { type: industryConstants.UPDATE_FAILURE, error } }
}
